<template>
    <div>

 <Form :model="splitOrderForm" :rules="ruleValidateSplitForm" label-position="top" ref="splitOrderForm">
     <Row :gutter="10">
        <Col span="20">
            <Tag color="primary" v-if="formIndex==0" style="float: right;font-weight: bolder">MAIN ORDER</Tag>
            <FormItem prop="name" label="Pickup Party">
                <ApolloQuery :query="query_SEARCH_PICKUPPARTY" :debounce="500" :skip="skip.pickupPartySkip"
                             :variables="{pickupPartyFilter:pickupPartyFilter}">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Pickup Party" @on-search="onSearchPickupParty($event)"
                                          v-model="splitOrderForm.name" v-if="$parent.$parent.splitOrderDrawer">
                                <Option :key="index" :value="companyObj.name" :label="companyObj.name"
                                        v-for="(companyObj,index) in data?data.addressbookedcompany:[]">
                                    <div class="ivu-select-item-div" @click="assignCompanyObj(companyObj)">{{companyObj.name}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </FormItem>
        </Col>
         <Col span="4" style="margin: 35px 0 0 0;text-decoration: underline;cursor: pointer">
             <div @click="startAddingCompany('pickup')">ADD</div>
         </Col>
         <Col span="24" v-if="splitOrderForm.pickupObj" style="margin-top: -20px;margin-bottom: 12px;font-size: 14px;">
             {{this.splitOrderForm.pickupObj.address[0].add1?this.splitOrderForm.pickupObj.address[0].add1+' ,':''}}
             {{this.splitOrderForm.pickupObj.address[0].add2?this.splitOrderForm.pickupObj.address[0].add2+' ,':''}}
             {{this.splitOrderForm.pickupObj.address[0].area}}, {{this.splitOrderForm.pickupObj.address[0].city}},
             {{this.splitOrderForm.pickupObj.address[0].state}} - {{this.splitOrderForm.pickupObj.address[0].pincode}}
         </Col>
      <!--  <Col span="24">
            <FormItem  prop="add1" label="Address 1">
                <Input placeholder="Address 1" v-model="splitOrderForm.add1"/>
            </FormItem>
        </Col>
        <Col span="24">
            <FormItem  prop="add2" label="Address 2">
                <Input placeholder="Address 2" v-model="splitOrderForm.add2"/>
            </FormItem>
        </Col>
        <Col span="12">
            <FormItem prop="area" label="Area">
                <Input placeholder="Area" v-model="splitOrderForm.area"/>
            </FormItem>
        </Col>
        <Col span="12">
            <FormItem  prop="pincode" label="Pincode">
                <Input number placeholder="PIN" v-model="splitOrderForm.pincode"/>
            </FormItem>
        </Col>
        <Col span="12" >
            <FormItem  prop="city" label="City">
                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter}"
                             :debounce="500" :skip="skip.citySkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="City" v-if="$parent.$parent.splitOrderDrawer"
                                          v-model="splitOrderForm.city" @on-search="onSearchCity">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.territories:[]">
                                    <div class="ivu-select-item-div">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </FormItem>
        </Col>
        <Col span="12">
            <FormItem prop="state" label="State">
                <ApolloQuery :query="query_SEARCH_STATE" :variables="{stateFilter}"
                             :debounce="500" :skip="skip.stateSkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="State" v-if="$parent.$parent.splitOrderDrawer"
                                          v-model="splitOrderForm.state" @on-search="onSearchState">
                                <Option :key="index" :value="stateObj.state" v-for="(stateObj,index) in data?data.territories:[]">
                                    <div class="ivu-select-item-div">{{stateObj.state}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </FormItem>
        </Col>               -->

        <Col span="10">
            <FormItem label="Quantity" prop="boxQuantity">
                <Input v-model="splitOrderForm.boxQuantity">
                <span slot="append">Boxes</span>
                </Input>
            </FormItem>
        </Col>
        <Divider type="vertical" />
        <Col span="6" style="margin: 26px 0 0 0">
            <FormItem prop="kgQuantity">
                <Input v-model="splitOrderForm.kgQuantity" type="number" @on-keydown="restrictCharacters($event)">
                <span slot="append">KG</span>
                </Input>
            </FormItem>
        </Col>
         <Col span="24">
         <FormItem label="Notes" prop="note">
             <Input type="textarea" :rows="4" placeholder="Enter note"
                    v-model="splitOrderForm.note"></Input>
         </FormItem>
         </Col>
    </Row>
 </Form>

        <company-drawer :initialCompanyType="initialCompanyType" ref="register-company-form"></company-drawer>

</div>
</template>

<script>
import gql from "graphql-tag";

const SEARCH_PICKUPPARTY_IN_SPLIT  =  gql`
  query addressbookedcompany($pickupPartyFilter: String!){
  addressbookedcompany(where: {_and: {name: {_ilike: $pickupPartyFilter} }}) {
    id
    name
    email
    mobile
    address
  }
  }
`
// import {SEARCH_PICKUPPARTY} from '../../graphql/queries/companies'
import { SEARCH_CITY, SEARCH_STATE } from '../../graphql/queries/territories'
import {UPDATE_PARENT_ORDER, ADD_ORDER_IN_MANAGE, ADD_ORDERDETAIL} from '../../graphql/mutations/orders'
import {Constants, generateUUID} from '../../Constants/Constant'
import CompanyDrawer from '../RegisterCompanyDrawer'
import moment from 'moment'
import _ from 'lodash'
    export default {
        name: "SplitOrder",
        props: ['formIndex', 'resetListener','submitListener'],
        components:{CompanyDrawer},
        data: function(){
          return{
              query_SEARCH_PICKUPPARTY: SEARCH_PICKUPPARTY_IN_SPLIT,
              query_SEARCH_CITY: SEARCH_CITY,
              query_SEARCH_STATE: SEARCH_STATE,
              mutation_UPDATE_PARENT_ORDER: UPDATE_PARENT_ORDER,
              mutation_ADD_ORDER: ADD_ORDER_IN_MANAGE,
              Constants: Constants,
              revertOrderIn: [Constants.internalStatus.underPickupProcess,Constants.internalStatus.readyForPickup,Constants.internalStatus.tempoOnTheWayToPickupLoad,
                              Constants.internalStatus.tempoWaitingForLoadingMaterial],
              splitOrderForm:{
                  name: '',
                  pickupObj: '',
                  add1: '',
                  add2: '',
                  area: '',
                  pincode: '',
                  state: '',
                  city: '',
                  boxQuantity: 0,
                  kgQuantity: 0,
                  note: '',
              },
              ruleValidateSplitForm: {
                  name: [{required: true, message: 'Please select Pickup Party', trigger: 'change'}],
                  add1: [{required: true, message: 'Please enter Address 1', trigger: 'change'}],
                  area: [{required: true, message: 'Please enter Area', trigger: 'change'}],
                  pincode: [{required: true, type:'number', message: 'Please enter Pincode', trigger: 'change'}],
                  city: [{required: true, message: 'Please select City', trigger: 'change'}],
                  state: [{required: true, message: 'Please select State', trigger: 'change'}],
                  boxQuantity: [{required: true, message: 'Please enter Boxes', trigger: 'change'}],
                  kgQuantity: [{validator: this.validateKgQty, trigger: 'change'}]
              },
              pickupPartyFilter: '%%',
              cityFilter: '%%',
              stateFilter: '%%',
              skip: {pickupPartySkip: true, citySkip: true, stateSkip: true},
              splitOrderNum : '',
              editCompanyDrawer: false,
              initialCompanyType: '',
              addToAddressBookOnly: true,
          }
        },
        watch:{
        /* ------------ Show only companies of present pickup city --------------- */
          '$parent.$parent.splitOrderDrawer': function(val){
            if(val){
              let addresses = this.$parent.$parent.orderData.pickuppartyobject.address
              let finalCondition = '';
              let intermediateCondition = '';
              if(addresses && addresses.length){
                addresses.forEach(function(curnt){
                  let pickupStr = '{address: {_contains: [{city: "'+ curnt.city +'"}]}},'
                  intermediateCondition = intermediateCondition + pickupStr
                })
                finalCondition = ', {_or: ['+ intermediateCondition +']}'
               this.query_SEARCH_PICKUPPARTY =   gql`query addressbookedcompany($pickupPartyFilter: String!){
                                                     addressbookedcompany(where: {_and: [{name: {_ilike: $pickupPartyFilter}}${finalCondition}]}) {
                                                                          id name email mobile address } }`
              }
            }
          }
        /* -----------------x----------------------x--------------------x---------- */
        },
        methods: {
            assignCompanyObj(companyObj){
                this.splitOrderForm.pickupObj=companyObj
                this.splitOrderForm.add1=companyObj.address[0].add1
                this.splitOrderForm.add2=companyObj.address[0].add2
                this.splitOrderForm.area=companyObj.address[0].area
                this.splitOrderForm.city=companyObj.address[0].city
                this.splitOrderForm.state=companyObj.address[0].state
                this.splitOrderForm.pincode=companyObj.address[0].pincode
            },
            startAddingCompany(str){
                if(str === 'pickup'){
                    this.initialCompanyType = '3a3248e1-f7a9-1982-1309-f9b6b780af40';
                    this.$refs['register-company-form'].companyRegistrationForm.userType = '3a3248e1-f7a9-1982-1309-f9b6b780af40';
                }
                this.addToAddressBookOnly = true;
                this.$refs['register-company-form'].companyType_skip = false;
                this.editCompanyDrawer = true;
            },
            onSearchPickupParty: function(val){
                this.pickupPartyFilter = '%' + val + '%';
                this.skip.pickupPartySkip = false;
            },
            onSearchCity: function(val){
                this.cityFilter = '%' + val + '%';
                this.skip.citySkip = false;
            },
            onSearchState: function(val){
                this.stateFilter = '%' + val + '%';
                this.skip.stateSkip = false;
            },
            validateKgQty(rule, value, callback){
                if(!value){
                    callback(new Error('Please enter KG'))
                }else if(value && value <= 0) {
                    callback(new Error('Invalid Qty'))
                }else {
                    callback()
                }
            },
            restrictCharacters(evt){
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if (charCode == 109 || charCode == 189 || charCode == 38 || charCode == 40) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            reset: function(){
                this.$refs['splitOrderForm'].resetFields();
            },
            validateForm(){
                let flag = false;
                this.$refs['splitOrderForm'].validate(function(valid) {
                    if (valid) {
                        flag = true
                    }
                })
                return flag
            },
            splitOrders(){
              if(this.formIndex == 0){
                  this.updateParentOrder();
              }else{
                  this.createNewOrder();
              }
            },
            async updateParentOrder(){
                let parentOrderData = this.$parent.$parent.orderData;
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_PARENT_ORDER,
                    variables: {
                        parentOrderId: parentOrderData.id,
                        orderNumber: parentOrderData.orderNumber + '/A',
                        pickuppartyid: this.splitOrderForm.pickupObj.id,
                        pickuppartyobject: {
                            id: this.splitOrderForm.pickupObj.id,
                            name: this.splitOrderForm.name,
                            mobile: this.splitOrderForm.pickupObj.mobile,
                            email: this.splitOrderForm.pickupObj.email,
                            address: [{add1: this.splitOrderForm.add1, add2: this.splitOrderForm.add2,
                                area: this.splitOrderForm.area, city: this.splitOrderForm.city,
                                pincode: this.splitOrderForm.pincode, state: this.splitOrderForm.state}],
                            latitude: null,
                            longitude: null,
                            mktgContactId: null,
                            dispatchContactId: null
                        },
                        materials: {type: parentOrderData.materials.type,
                            boxes: this.splitOrderForm.boxQuantity,
                            kg: parseInt(this.splitOrderForm.kgQuantity)
                        },
                        updatedAt: moment().format(),
                        note: this.splitOrderForm.note,
                        internalstatus: this.revertOrderIn.includes(parentOrderData.internalStatus.id)?
                                        Constants.internalStatus.orderNotReady:parentOrderData.internalStatus.id
                    }
                })
                if(response.data){
                    this.$Message.success('Parent Order updated successfully!');
                    this.reset();
                    this.$parent.$parent.splitOrderDrawer = false;
                }
            },
            async createNewOrder(){
                let parentOrderData = this.$parent.$parent.orderData;
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_ADD_ORDER,
                    variables: {
                        pickupDate: parentOrderData.pickupDate,
                        id: generateUUID(),
                        orderNumber: parentOrderData.orderNumber + '/' + String.fromCharCode(65 + this.formIndex),
                        createdAt: moment().format(),
                        updatedAt: moment().format(),
                        clientid: parentOrderData.clientobject.id,
                        clientobject: parentOrderData.clientobject,
                        pickuppartyid: this.splitOrderForm.pickupObj.id,
                        pickuppartyobject: {
                            id: this.splitOrderForm.pickupObj.id,
                            name: this.splitOrderForm.name,
                            mobile: this.splitOrderForm.pickupObj.mobile,
                            email: this.splitOrderForm.pickupObj.email,
                            address: [{add1: this.splitOrderForm.add1, add2: this.splitOrderForm.add2,
                            area: this.splitOrderForm.area, city: this.splitOrderForm.city,
                            pincode: this.splitOrderForm.pincode, state: this.splitOrderForm.state}],
                            latitude: null,
                            longitude: null,
                            mktgContactId: null,
                            dispatchContactId: null
                        },
                        droppingpartyid: parentOrderData.droppingpartyobject.id,
                        droppingpartyobject: parentOrderData.droppingpartyobject,
                        materials: {type: parentOrderData.materials.type,
                            boxes: this.splitOrderForm.boxQuantity,
                            kg: parseInt(this.splitOrderForm.kgQuantity)
                        },
                        note: this.splitOrderForm.note,
                        priority: parentOrderData.priority,
                        internalstatus: this.revertOrderIn.includes(parentOrderData.internalStatus.id)?
                                        Constants.internalStatus.orderNotReady:parentOrderData.internalStatus.id,
                        externalstatus: parentOrderData.externalStatus.id,
                        parentOrderId: parentOrderData.id
                    }
                })
                if(response.data){
                    this.insertOrderDetail(response.data.insert_orders.returning[0].id, parentOrderData);
                    this.$Message.success('Order created successfully!');
                    this.reset();
                    this.$parent.$parent.splitOrderDrawer = false;
                }
            },
           async insertOrderDetail(orderId, parentOrderData){
            let orderDetailRequest = {
              id: generateUUID(),
              orderId: orderId,
              pickupPoint: parentOrderData.orderDetails.pickupPoint,
              dropPoint: parentOrderData.orderDetails.dropPoint,
              orderReadiness: parentOrderData.orderDetails.orderReadiness,
              lrObject: parentOrderData.orderDetails.lrObject,
              pickupConfirmation: parentOrderData.orderDetails.pickupConfirmation,
              dispactchVerification: parentOrderData.orderDetails.dispactchVerification,
              loadedInTruck: parentOrderData.orderDetails.loadedInTruck,
              ewayBillNo: parentOrderData.orderDetails.ewayBillNo,
              isEwayBillVerified: parentOrderData.orderDetails.isEwayBillVerified,
              pickupVehicleAssignId: parentOrderData.orderDetails.pickupVehicleAssignId,
              transportVehicleAssignId: parentOrderData.orderDetails.transportVehicleAssignId,

            }
            let response = await this.$apollo.mutate({
              mutation: ADD_ORDERDETAIL,
              variables: {orderDetailObj: orderDetailRequest},
            })
            if(response.data){
              this.$Message.success('Order detail saved successfully!');
            }
          }
        },
        mounted() {
            this.resetListener.$on('reset', this.reset)
            this.submitListener.$on('splitOrder', this.splitOrders)
        },
        beforeDestroy(){
            this.resetListener.$off('reset', this.reset)
            this.submitListener.$off('splitOrder', this.splitOrders)
        }
    }
</script>

<style scoped>
   /deep/ .ivu-select-item{
        padding: 0px 0px;
    }
    .ivu-select-item-div{
        width: 100%;
        padding: 7px 16px;
    }
   /deep/ .ivu-auto-complete.ivu-select-dropdown{
     max-height: 200px !important;
   }

</style>
